<main class="reativacao" [class.com-barra]="tela === 'filtros'">
  <header class="topo">
    <div class="topo__titulo">
      <a class="migalha" routerLink="/admin/mia-gestor/leads"><i class="fas fa-chevron-left" aria-hidden="true"></i> Leads</a>
      <h1><span class="topo__icone"><i class="fas fa-sync-alt" aria-hidden="true"></i></span>Reativar leads</h1>
      <p>Escolha quem recebe. A Mia manda um por vez, no ritmo de marketing do número. Pode fechar esta tela: o envio é do servidor.</p>
    </div>
    <div class="periodo" role="group" aria-label="Período do cadastro" *ngIf="tela === 'filtros'">
      <button type="button" *ngFor="let p of periodos" [class.ativo]="dias === p.dias" [attr.aria-pressed]="dias === p.dias"
              (click)="mudePeriodo(p.dias)">{{ p.rotulo }}</button>
    </div>
  </header>

  <div class="erro" *ngIf="erro" role="alert"><i class="fas fa-exclamation-circle" aria-hidden="true"></i>{{ erro }}
    <button type="button" (click)="erro = ''" aria-label="Fechar aviso"><i class="fas fa-times" aria-hidden="true"></i></button>
  </div>

  <div class="vazio" *ngIf="tela === 'carregando'"><i class="fas fa-circle-notch girando" aria-hidden="true"></i> Carregando…</div>

  <!-- ===================== filtros, mensagem e prévia ===================== -->
  <div class="grade" *ngIf="tela === 'filtros'">
    <div class="coluna">
      <label class="busca">
        <i class="fas fa-search" aria-hidden="true"></i>
        <input type="search" [(ngModel)]="busca" (ngModelChange)="mudou(400)" placeholder="Buscar por nome, loja, Instagram ou telefone" aria-label="Buscar lead">
      </label>

      <section>
        <div class="rotulo-bloco"><h2>Etapa</h2><span>toque para incluir ou tirar</span></div>
        <div class="cartao">
          <div class="etapas">
            <button type="button" class="etapa" *ngFor="let e of etapas" [class.on]="etapasEscolhidas.has(e.id)" [style.--cor]="e.cor"
                    [attr.aria-pressed]="etapasEscolhidas.has(e.id)" (click)="alterneEtapa(e.id)">
              <span class="marca"><i class="fas fa-check" aria-hidden="true"></i></span>
              <span class="etapa__topo"><span class="etapa__icone"><i class="fas {{ e.icone }}" aria-hidden="true"></i></span>{{ e.nome }}</span>
              <span class="etapa__n num">{{ contagem('etapas', e.id) ?? '–' }}</span>
              <span class="etapa__msg">{{ e.mensagem }}</span>
            </button>
          </div>
          <div class="fora-do-lote">
            <span class="ponto" style="background:#22c55e"></span>Cliente
            <span class="ponto" style="background:#9ca3af"></span>Perdido · não entram na reativação; para eles use "Chamar a Mia" no cartão.
          </div>
        </div>
      </section>

      <section>
        <div class="rotulo-bloco"><h2>Conversa</h2></div>
        <div class="cartao">
          <div class="linha">
            <div class="linha__nome"><span class="linha__icone" style="--c:#0ea5a4"><i class="fas fa-comment" aria-hidden="true"></i></span>
              <div>Situação<small>quem está devendo resposta</small></div></div>
            <div class="chips">
              <button type="button" class="chip" *ngFor="let o of situacoes" [class.on]="situacoesEscolhidas.has(o.id)"
                      [class.zero]="contagem('situacoes', o.id) === 0" (click)="alterne(situacoesEscolhidas, o.id)">
                <i class="fas {{ o.icone }}" aria-hidden="true"></i>{{ o.nome }} <span class="n num">{{ contagem('situacoes', o.id) }}</span>
              </button>
            </div>
          </div>
          <div class="linha">
            <div class="linha__nome"><span class="linha__icone" style="--c:#f59e0b"><i class="fas fa-clock" aria-hidden="true"></i></span>
              <div>Sem contato há<small>última fala do lead, da Mia ou da equipe</small></div></div>
            <div class="chips">
              <button type="button" class="chip" *ngFor="let o of silencios" [class.on]="diasSemContato === o.id"
                      [class.zero]="contagem('diasSemContato', o.id) === 0" (click)="escolhaSilencio(o.id)">
                {{ o.nome }} <span class="n num">{{ contagem('diasSemContato', o.id) }}</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="rotulo-bloco"><h2>Perfil do lead</h2></div>
        <div class="cartao">
          <div class="linha">
            <div class="linha__nome"><span class="linha__icone" style="--c:#3b82f6"><i class="fas fa-globe" aria-hidden="true"></i></span>
              <div>Canal<small>por onde o lead chegou</small></div></div>
            <div class="chips">
              <button type="button" class="chip" *ngFor="let o of canaisDisponiveis; trackBy: trackPorId" [class.on]="canais.has(o.id)"
                      [class.zero]="contagem('canais', o.id) === 0" (click)="alterne(canais, o.id)">
                <i class="fas {{ o.icone }}" aria-hidden="true"></i>{{ o.nome }} <span class="n num">{{ contagem('canais', o.id) }}</span>
              </button>
              <span class="sem-opcao" *ngIf="!canaisDisponiveis.length">Nenhum lead no período</span>
            </div>
          </div>
          <div class="linha">
            <div class="linha__nome"><span class="linha__icone" style="--c:#ec4899"><i class="fas fa-tag" aria-hidden="true"></i></span>
              <div>Origem<small>quem cadastrou o lead</small></div></div>
            <div class="chips">
              <button type="button" class="chip" *ngFor="let o of origensDisponiveis; trackBy: trackPorId" [class.on]="origens.has(o.id)"
                      [class.zero]="contagem('origens', o.id) === 0" (click)="alterne(origens, o.id)">
                <i class="fas {{ o.icone }}" aria-hidden="true"></i>{{ o.nome }} <span class="n num">{{ contagem('origens', o.id) }}</span>
              </button>
            </div>
          </div>
          <div class="linha">
            <div class="linha__nome"><span class="linha__icone" style="--c:#8b5cf6"><i class="fas fa-flask" aria-hidden="true"></i></span>
              <div>Teste<small>entrou no painel depois de criar</small></div></div>
            <div class="chips">
              <button type="button" class="chip" *ngFor="let o of testes" [class.on]="acessouTeste === o.id"
                      [class.zero]="o.chave && contagem('acessouTeste', o.chave) === 0" (click)="escolhaTeste(o.id)">
                <i *ngIf="o.icone" class="fas {{ o.icone }}" aria-hidden="true"></i>{{ o.nome }}
                <span class="n num" *ngIf="o.chave">{{ contagem('acessouTeste', o.chave) }}</span>
              </button>
            </div>
          </div>
          <div class="linha">
            <div class="linha__nome"><span class="linha__icone" style="--c:#64748b"><i class="fas fa-desktop" aria-hidden="true"></i></span>
              <div>Computador<small>respondido no formulário</small></div></div>
            <div class="chips">
              <button type="button" class="chip" *ngFor="let o of computadores" [class.on]="temComputador === o.id"
                      [class.zero]="o.chave && contagem('temComputador', o.chave) === 0" (click)="escolhaComputador(o.id)">
                <i *ngIf="o.icone" class="fas {{ o.icone }}" aria-hidden="true"></i>{{ o.nome }}
                <span class="n num" *ngIf="o.chave">{{ contagem('temComputador', o.chave) }}</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- ===== mensagem ===== -->
      <section>
        <div class="rotulo-bloco"><h2>Mensagem</h2><span>o que cada lead recebe</span></div>
        <div class="cartao">
          <div class="modo">
            <button type="button" class="modo__op" [class.on]="modo === 'MIA'" (click)="escolhaModo('MIA')" [attr.aria-pressed]="modo === 'MIA'">
              <span class="linha__icone" style="--c:#16a34a"><i class="fas fa-magic" aria-hidden="true"></i></span>
              <span><b>A Mia escreve</b><small>uma para cada lead, pela situação dele: abordagem fria, retomada ou acesso à loja</small></span>
            </button>
            <button type="button" class="modo__op" [class.on]="modo === 'FIXO'" (click)="escolhaModo('FIXO')" [attr.aria-pressed]="modo === 'FIXO'">
              <span class="linha__icone" style="--c:#64748b"><i class="fas fa-file-alt" aria-hidden="true"></i></span>
              <span><b>Texto fixo</b><small>você escreve; muda só o nome e a loja</small></span>
            </button>
          </div>

          <ng-container *ngIf="modo === 'MIA'">
            <div class="campo">
              <label class="campo__rotulo" for="orientacao">Orientação para a Mia <small>opcional · vale para todos, cada um no seu contexto</small></label>
              <textarea id="orientacao" rows="3" maxlength="400" [(ngModel)]="orientacao"
                        placeholder="Ex.: fale da condição de outubro, primeiro mês por R$ 49,90. Não ofereça desconto além disso."></textarea>
              <div class="sugestoes">
                <span>Ideias:</span>
                <button type="button" class="chip" *ngFor="let i of ideias" (click)="useIdeia(i.texto)">{{ i.rotulo }}</button>
              </div>
            </div>
            <div class="campo exemplos-topo">
              <div><b>Exemplos</b><small>3 leads deste filtro. Nada é enviado; a mensagem real é escrita na hora do envio.</small></div>
              <button type="button" class="botao botao--secundario" (click)="gereExemplos()" [disabled]="gerandoExemplos || !previa?.total">
                <i class="fas" [class.fa-magic]="!gerandoExemplos" [class.fa-circle-notch]="gerandoExemplos" [class.girando]="gerandoExemplos" aria-hidden="true"></i>
                {{ gerandoExemplos ? 'Montando…' : 'Gerar exemplos' }}
              </button>
            </div>
            <div class="conversas conversas--exemplos" *ngIf="exemplos.length">
              <div class="conversa" *ngFor="let ex of exemplos">
                <div class="conversa__quem"><span class="avatar avatar--p" [ngStyle]="pastel(ex.leadId)">{{ iniciais(ex.nome) }}</span>
                  <span>{{ ex.nome || 'Sem nome' }} <small>· {{ etapa(ex.etapa).nome }}</small></span></div>
                <div class="bolha bolha--erro" *ngIf="ex.erro">{{ ex.erro }}</div>
                <ng-container *ngIf="!ex.erro">
                  <img class="bolha__imagem bolha" *ngIf="imagem" [src]="urlDaImagem" alt="Imagem da reativação">
                  <div class="bolha" [innerHTML]="bolha(ex.texto)"></div>
                  <div class="bolha-botao" *ngFor="let b of ex.botoes">{{ b }}</div>
                  <div class="bolha-botao" *ngIf="ex.link">🔗 {{ ex.link }}</div>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="modo === 'FIXO'">
            <div class="campo">
              <div class="campo__rotulo">Versões <small>a Mia alterna entre elas</small></div>
              <div class="chips versoes">
                <button type="button" class="chip" *ngFor="let v of versoes; let i = index; trackBy: trackPorIndice" [class.on]="i === versaoAtual"
                        (click)="escolhaVersao(i)">Versão {{ i + 1 }} <span class="n" *ngIf="!v.trim()">vazia</span></button>
                <button type="button" class="chip chip--nova" *ngIf="versoes.length < 5" (click)="novaVersao()">+ Versão</button>
              </div>
              <textarea #campoTexto rows="5" maxlength="700" [(ngModel)]="versoes[versaoAtual]" (ngModelChange)="mudou(600)"
                        aria-label="Texto da versão"></textarea>
              <div class="variaveis">
                <span>Inserir:</span>
                <button type="button" class="chip chip--var" (click)="insira('{primeiro_nome}', campoTexto)">{{ '{' }}primeiro_nome{{ '}' }}</button>
                <button type="button" class="chip chip--var" (click)="insira('{loja}', campoTexto)">{{ '{' }}loja{{ '}' }}</button>
                <span class="contador num">{{ versoes[versaoAtual].length }}/700</span>
              </div>
              <div class="aviso" *ngIf="versoesPreenchidas < 2">
                <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
                <span>O mesmo texto para muita gente faz o WhatsApp bloquear o número. Escreva pelo menos 2 versões.</span>
              </div>
            </div>
            <div class="campo">
              <div class="campo__rotulo">Botão</div>
              <div class="chips">
                <button type="button" class="chip" [class.on]="botao === 'NENHUM'" (click)="botao = 'NENHUM'">Sem botão</button>
                <button type="button" class="chip" [class.on]="botao === 'TESTE'" (click)="botao = 'TESTE'">🎁 Testar 7 dias</button>
                <button type="button" class="chip" [class.on]="botao === 'LINK'" (click)="botao = 'LINK'"><i class="fas fa-link" aria-hidden="true"></i>Link</button>
              </div>
              <input class="entrada" *ngIf="botao === 'LINK'" [(ngModel)]="link" placeholder="https://meucardapio.ai/…" aria-label="Endereço do link">
            </div>
            <div class="campo">
              <div class="campo__rotulo">Como chega <small *ngIf="leadDeExemplo">exemplo com {{ leadDeExemplo.nome || 'um lead sem nome' }}</small></div>
              <div class="conversa" *ngIf="leadDeExemplo">
                <div class="conversa__quem"><span class="avatar avatar--p" [ngStyle]="pastel(leadDeExemplo.id)">{{ iniciais(leadDeExemplo.nome) }}</span>
                  <span>{{ leadDeExemplo.nome || 'Sem nome' }} <small>· {{ etapa(leadDeExemplo.etapa).nome }}</small></span></div>
                <img class="bolha__imagem bolha" *ngIf="imagem && botao !== 'NENHUM'" [src]="urlDaImagem" alt="Imagem da reativação">
                <div class="bolha">
                  <img class="bolha__imagem" *ngIf="imagem && botao === 'NENHUM'" [src]="urlDaImagem" alt="Imagem da reativação">
                  <span [innerHTML]="bolha(textoFixoDoExemplo())"></span>
                </div>
                <div class="bolha-botao" *ngIf="botao === 'TESTE'">🎁 Testar 7 dias</div>
                <div class="bolha-botao" *ngIf="botao === 'LINK'">🔗 Abrir</div>
              </div>
              <p class="nota">Se o lead responder, a Mia continua a conversa a partir desta mensagem.</p>
            </div>
          </ng-container>

          <div class="campo">
            <div class="campo__rotulo">Imagem <small>opcional</small></div>
            <label class="imagem-zona" *ngIf="!imagem">
              <input type="file" accept="image/png,image/jpeg,image/webp" hidden (change)="envieImagem($event)">
              <i class="fas" [class.fa-image]="!enviandoImagem" [class.fa-circle-notch]="enviandoImagem" [class.girando]="enviandoImagem" aria-hidden="true"></i>
              <span><b>{{ enviandoImagem ? 'Enviando…' : 'Adicionar imagem' }}</b>
                <small>JPG, PNG ou WebP até 5 MB. {{ modo === 'MIA' ? 'Sai logo antes da mensagem da Mia.' : 'Vai junto com o texto, como legenda.' }}</small></span>
            </label>
            <div class="imagem-escolhida" *ngIf="imagem">
              <img [src]="urlDaImagem" alt="Imagem escolhida">
              <div><b>Imagem da reativação</b>
                <small>{{ modo === 'MIA' ? 'Sai logo antes da mensagem da Mia.' : botao !== 'NENHUM' ? 'Com botão, sai antes do texto, numa mensagem separada.' : 'Vai junto com o texto, como legenda.' }}</small></div>
              <button type="button" class="botao botao--perigo" (click)="tireImagem()"><i class="fas fa-times" aria-hidden="true"></i>Tirar</button>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="rotulo-bloco"><h2>Quem vai receber · {{ previa?.total || 0 }}</h2><span>quem chegou mais longe no funil sai primeiro</span></div>
        <div class="cartao">
          <div class="vazio vazio--dentro" *ngIf="!previa?.total">Ninguém com estes filtros.</div>
          <div class="lista__linha" *ngFor="let l of leadsVisiveis">
            <span class="avatar" [ngStyle]="pastel(l.id)">{{ iniciais(l.nome) }}</span>
            <div class="lista__quem"><div class="lista__nome">{{ l.nome || 'Sem nome' }}</div><div class="lista__sub">{{ l.empresa || '—' }}</div></div>
            <div class="lista__dir"><span class="etiqueta"><span class="ponto" [style.background]="etapa(l.etapa).cor"></span>{{ etapa(l.etapa).mensagem }}</span>
              <small>último contato {{ semContato(l.minutosSemContato) }}</small></div>
          </div>
          <button type="button" class="lista__mais" *ngIf="(previa?.total || 0) > 8" (click)="mostrarTodos = !mostrarTodos">
            {{ mostrarTodos ? 'Mostrar menos' : 'Ver todos os ' + previa?.total }}
          </button>
        </div>
      </section>
    </div>

    <aside class="cartao previa" aria-live="polite">
      <div class="previa__topo">
        <div class="rotulo">Vão receber <i class="fas fa-circle-notch girando" *ngIf="carregandoPrevia" aria-hidden="true"></i></div>
        <div class="total"><strong class="num">{{ previa?.total || 0 }}</strong><span>leads</span></div>
        <div class="barra"><i *ngFor="let e of porEtapa; trackBy: trackPorId" [style.width.%]="e.pct" [style.background]="e.cor"></i></div>
        <div class="legenda">
          <ng-container *ngFor="let e of porEtapa; trackBy: trackPorId">
            <div *ngIf="e.n"><span class="ponto" [style.background]="e.cor"></span>{{ e.nome }}<small>· {{ e.mensagem | lowercase }}</small><b class="num">{{ e.n }}</b></div>
          </ng-container>
        </div>
        <div class="resumo-msg"><span *ngFor="let r of resumoDaMensagem; trackBy: trackPorIndice"><i class="fas {{ r.icone }}" aria-hidden="true"></i>{{ r.texto }}</span></div>
      </div>

      <div class="secao" *ngIf="previa && !previa.extensaoConectada">
        <div class="aviso aviso--forte"><i class="fas fa-plug" aria-hidden="true"></i>
          <span>A extensão da Gestor está desconectada agora. Você pode disparar: a fila espera e começa quando ela reconectar.</span></div>
      </div>

      <div class="secao">
        <div class="secao__titulo"><i class="fas fa-calendar-alt" aria-hidden="true"></i>Envios por dia
          <span *ngIf="previa?.ritmo">{{ previa.ritmo.janelaInicioHora }}h às {{ previa.ritmo.janelaFimHora }}h</span></div>
        <div class="dias">
          <div class="dia" *ngFor="let d of enviosPorDia; trackBy: trackPorIndice" [class.dia--vazio]="!d.n">
            <span class="dia__n num">{{ d.n || '–' }}</span>
            <div class="dia__trilho"><div class="dia__barra" [style.height.%]="d.n ? (d.pct < 6 ? 6 : d.pct) : 0"></div></div>
            <span class="dia__nome">{{ d.nome }}</span>
          </div>
        </div>
        <p class="previsao" *ngIf="previsao">{{ previsao }}</p>
        <div class="ritmo" *ngIf="previa?.ritmo">
          <span><i class="fas fa-clock" aria-hidden="true"></i>1 a cada {{ intervaloEmMinutos }}</span>
          <span><i class="fas fa-tachometer-alt" aria-hidden="true"></i>até {{ previa.ritmo.porHora }} por hora</span>
          <span><i class="fas fa-shield-alt" aria-hidden="true"></i>teto de {{ previa.ritmo.porDia }} por dia</span>
        </div>
        <div class="aviso" *ngIf="frios">
          <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
          <span>{{ frios }} nunca escreveram e recebem abordagem fria. São os que mais denunciam no WhatsApp pessoal; vale começar por quem já conversou.</span>
        </div>
      </div>

      <div class="secao">
        <div class="secao__titulo"><i class="fas fa-shield-alt" aria-hidden="true"></i>Ficam de fora por proteção
          <span *ngIf="totalForaDoLote">{{ totalForaDoLote }} leads</span></div>
        <div class="protecoes">
          <div *ngFor="let p of foraDoLote"><span class="ponto"></span>{{ p.rotulo }}<b class="num">{{ p.quantidade }}</b></div>
          <div class="vazio-linha" *ngIf="!foraDoLote.length">Ninguém</div>
        </div>
      </div>

      <div class="rodape rodape--disparo">
        <button type="button" class="botao botao--primario" (click)="dispare()" [disabled]="!previa?.total || !mensagemPronta || disparando || carregandoPrevia">
          <i class="fas" [class.fa-paper-plane]="!disparando" [class.fa-circle-notch]="disparando" [class.girando]="disparando" aria-hidden="true"></i>
          {{ !mensagemPronta ? 'Complete a mensagem fixa' : previa?.total ? 'Disparar para ' + previa.total + ' leads' : 'Disparar reativação' }}
        </button>
        <p>Sai um por vez. Dá para pausar ou cancelar a qualquer momento.</p>
      </div>
    </aside>
  </div>

  <!-- barra fixa no celular -->
  <div class="barra-celular" *ngIf="tela === 'filtros'">
    <div><strong class="num">{{ previa?.total || 0 }}</strong><small>leads vão receber</small></div>
    <button type="button" class="botao botao--primario" (click)="dispare()" [disabled]="!previa?.total || !mensagemPronta || disparando || carregandoPrevia">
      <i class="fas fa-paper-plane" aria-hidden="true"></i>Disparar
    </button>
  </div>

  <!-- ===================== acompanhamento ===================== -->
  <div class="grade" *ngIf="tela === 'andamento' && lote">
    <div class="coluna">
      <div class="cartao andamento">
        <div class="andamento__linha">
          <div>
            <div class="rotulo">Reativação disparada {{ criadoHa }}</div>
            <div class="andamento__titulo">{{ lote.total }} leads</div>
          </div>
          <span class="selo {{ selo.classe }}"><span class="selo__pulso"></span>{{ selo.texto }}</span>
        </div>
        <div class="progresso"><i *ngFor="let p of progresso; trackBy: trackPorIndice" [style.width.%]="p.pct" [style.background]="p.cor"></i></div>
        <div class="kpis">
          <div class="kpi"><span class="kpi__icone" style="background:#16a34a"><i class="fas fa-check" aria-hidden="true"></i></span>
            <div><strong class="num">{{ lote.enviados }}</strong><span>enviados</span></div></div>
          <div class="kpi"><span class="kpi__icone" style="background:#2d5cb8"><i class="fas fa-inbox" aria-hidden="true"></i></span>
            <div><strong class="num">{{ lote.pendentes }}</strong><span>na fila</span></div></div>
          <div class="kpi"><span class="kpi__icone" style="background:#9aa3b2"><i class="fas fa-step-forward" aria-hidden="true"></i></span>
            <div><strong class="num">{{ lote.pulados }}</strong><span>pulados</span></div></div>
          <div class="kpi"><span class="kpi__icone" style="background:#dc2626"><i class="fas fa-times" aria-hidden="true"></i></span>
            <div><strong class="num">{{ lote.falhos }}</strong><span>falharam</span></div></div>
        </div>
        <div class="proximo" [class.proximo--alerta]="situacao && !situacao.extensaoConectada && !loteTerminou">
          <i class="fas" [class.fa-clock]="situacao?.extensaoConectada || loteTerminou" [class.fa-plug]="situacao && !situacao.extensaoConectada && !loteTerminou" aria-hidden="true"></i>
          <span>{{ proximoEnvio }}</span>
        </div>
        <p class="nota">Pulado = respondeu, pediu para parar ou foi movido enquanto esperava a vez. A Mia confere de novo na hora de enviar.</p>
        <button type="button" class="lista__mais lista__mais--rodape" *ngIf="loteTerminou" (click)="novaReativacao()">
          <i class="fas fa-arrow-left" aria-hidden="true"></i> Voltar aos filtros para uma nova reativação
        </button>
      </div>
    </div>

    <aside class="cartao previa">
      <div class="previa__topo previa__topo--curto"><div class="rotulo">Últimos envios</div></div>
      <div class="vazio vazio--dentro" *ngIf="!situacao?.ultimos?.length">Aguardando o primeiro envio…</div>
      <div class="envio" *ngFor="let item of situacao?.ultimos">
        <span class="avatar" [ngStyle]="pastel(item.leadId)">{{ iniciais(item.nome) }}</span>
        <div class="lista__quem"><div class="lista__nome">{{ item.nome || 'Sem nome' }}</div><div class="lista__sub">{{ detalheDoItem(item) }}</div></div>
        <div class="envio__estado" [class.verde]="item.estado === 'ENVIADO'" [class.vermelho]="item.estado === 'FALHOU'">
          <i class="fas" [class.fa-check]="item.estado === 'ENVIADO'" [class.fa-times]="item.estado === 'FALHOU'"
             [class.fa-step-forward]="item.estado === 'PULADO'" aria-hidden="true"></i>
          {{ item.estado === 'ENVIADO' ? 'Enviado' : item.estado === 'FALHOU' ? 'Falhou' : 'Pulado' }}
          <small>{{ haQuanto(item.minutosAtras) }}</small>
        </div>
      </div>
      <div class="rodape" *ngIf="!loteTerminou">
        <div class="duas">
          <button type="button" class="botao botao--secundario" (click)="acao(lote.estado === 'PAUSADA' ? 'retomar' : 'pausar')" [disabled]="agindo">
            <i class="fas" [class.fa-pause]="lote.estado !== 'PAUSADA'" [class.fa-play]="lote.estado === 'PAUSADA'" aria-hidden="true"></i>
            {{ lote.estado === 'PAUSADA' ? 'Retomar' : 'Pausar' }}
          </button>
          <button type="button" class="botao botao--perigo" (click)="acao('cancelar')" [disabled]="agindo"><i class="fas fa-times" aria-hidden="true"></i>Cancelar</button>
        </div>
        <p>Cancelar tira da fila quem ainda não recebeu; o que já saiu fica.</p>
      </div>
    </aside>
  </div>
</main>
